import {type Middleware} from 'instantsearch.js';
import {type ReactNode, useEffect, useRef} from 'react';
import {useInstantSearch} from 'react-instantsearch';

type IndexUiState = {
    page?: number;
    sortBy?: string;
    query?: string;
    refinementList?: Record<string, string[]>;
};

export function ScrollTo({children}: { children: ReactNode }) {
    const {addMiddlewares} = useInstantSearch();

    const containerRef = useRef<HTMLDivElement>(null);
    const previousStateRef = useRef<IndexUiState>({});

    useEffect(() => {
        const middleware: Middleware = () => {
            return {
                onStateChange({uiState}) {
                    const indexId = Object.keys(uiState)[0];
                    const nextState: IndexUiState = indexId ? uiState[indexId] as IndexUiState : {};
                    const previousState = previousStateRef.current;
                    previousStateRef.current = nextState;

                    const isTyping =
                        document.activeElement?.tagName === 'INPUT' &&
                        document.activeElement?.getAttribute('type') === 'search';

                    // Only scroll when the page actually changed via pagination,
                    // not when sorting or filters change (which also touch the page).
                    const isPaginationOnlyChange =
                        nextState.page !== previousState.page &&
                        nextState.sortBy === previousState.sortBy &&
                        nextState.query === previousState.query &&
                        JSON.stringify(nextState.refinementList) === JSON.stringify(previousState.refinementList);

                    if (isTyping || !isPaginationOnlyChange) {
                        return;
                    }
                    containerRef.current!.scrollIntoView({block: "start"});
                },
            };
        };

        return addMiddlewares(middleware);
    }, [addMiddlewares]);

    return (
        <div ref={containerRef} className={"algoliaScrollTo"}>
            {children}
        </div>
    );
}
